/*
 * @Descripttion: 存证确认
 * @Date: 2024-03-27 13:08:09
 */
import { DefineComponent } from 'vue';
import LoginFormVue from './login-form.vue';
import type { FormProps } from '../../types/index';

export const LoginForm = LoginFormVue as unknown as DefineComponent<FormProps>;
